import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

class Edit extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      auctionAccessBlacklist,
    } = this.props;

    return (
      <Form
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        onSubmitHandler={onSubmitHandler}
        error={error}
        submitting={submitting}
        auctionAccessBlacklist={auctionAccessBlacklist}
        action='edit'
      />
    );
  }
}

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  auctionAccessBlacklist: PropTypes.object,
};

Edit.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: null,
  submitting: false,
  auctionAccessBlacklist: {},
};

export default Edit;
